import {useAtom} from 'jotai'

import {
  categoriesAtom,
  detailAtom,
  familysAtom,
  listActiveAtom,
  listActiveFilterAtom,
  listActiveFilterNotPackageAtom,
  listAtom,
  listFilterAtom,
  subCategoriesAtom,
  visibilitysAtom,
} from '../store'

export const useItem = () => {
  const [list, listSet] = useAtom(listAtom)
  const [listActive, listActiveSet] = useAtom(listActiveAtom)
  const [listFilter, listFilterSet] = useAtom(listFilterAtom)
  const [listActiveFilter, listActiveFilterSet] = useAtom(listActiveFilterAtom)
  const [listActiveFilterNotPackage, listActiveFilterNotPackageSet] = useAtom(
    listActiveFilterNotPackageAtom
  )

  const [detail, detailSet] = useAtom(detailAtom)

  const [visibility, visibilitySet] = useAtom(visibilitysAtom)
  const [categories, categoriesSet] = useAtom(categoriesAtom)
  const [subCategories, subCategoriesSet] = useAtom(subCategoriesAtom)
  const [family, familySet] = useAtom(familysAtom)

  return {
    list,
    listSet,
    listActive,
    listActiveSet,
    listFilter,
    listFilterSet,
    listActiveFilter,
    listActiveFilterSet,
    listActiveFilterNotPackage,
    listActiveFilterNotPackageSet,
    detail,
    detailSet,
    categories,
    categoriesSet,
    subCategories,
    subCategoriesSet,
    family,
    familySet,
    visibility,
    visibilitySet,
  }
}
